import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import {
  CONTENT_BLOCK,
  BUTTON,
  TEXT_AREA,
  IMAGE_CONTENT,
  DROPDOWN,
  TITLE
} from "./baseModal/FieldTypes";
import BaseModal from "./baseModal/BaseModal";
import {
  BLUE_BUTTON,
  GREEN_BUTTON,
  RED_BUTTON,
  WHITE,
  YELLOW_BUTTON
} from "./baseModal/colours";

class ApplicationViewModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      message: ""
    };
  }

  getBaseModalFields() {
    const titleField = {
      type: TITLE,
      data: {
        name: "NOTE: By clicking on 'Confirm' the application will be cancelled."
      }
    };

    const allFields = [];
    allFields.push(titleField);
    return allFields;
  }

  getBaseModalButtons() {
    const cancelButton = {
      name: "Confirm",
      handleClick: () => this.props.cancelApplication(),
      buttonColour: RED_BUTTON,
      textColour: WHITE,
      isDisabled: this.props.canSubUserEdit
    };
    return [cancelButton];
  }

  getBaseModalProps() {
    const baseModalProps = {
      title: "Cancel Application",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: this.props.onClose
    };

    return baseModalProps;
  }

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(ApplicationViewModal);
